import React from "react";

import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import Logo from "shared/components/Logo";
import Folder from "shared/components/SVG/Folder";
import { NAME_SPACES } from "shared/locals/constants";
import { PATHS } from "utils/constants";

import "./styles.scss";

const Component = () => {
  const history = useHistory();
  const { t } = useTranslation(NAME_SPACES.HOME, { keyPrefix: "EMPTY_FOLDER" });

  return (
    <div className={"empty-folder-wrapper"}>
      <div className={"empty-folder"}>
        <div className={"empty-folder-logo"}>
          <Logo width={128} />
        </div>
        <div className={"empty-folder-icon"}>
          <Folder />
        </div>
        <p className={"empty-folder-title"}>{t("TITLE")}</p>
        <p className={"empty-folder-description"}>{t("DESCRIPTION")}</p>
        <u
          onClick={() => {
            history.push(PATHS.FILE.NEW);
          }}>
          <p>{t("LINK")}</p>
        </u>
      </div>
    </div>
  );
};

Component.propTypes = {};

export default Component;
